import { Scaling, BadgeDollarSign, ShieldCheck, Globe } from "lucide-react";

const solutions = [
  {
    icon: Scaling,
    title: "Scalability",
    description:
      "Easily adjust your resources based on business demand. Whether you're expanding or need to scale down, our cloud solutions adapt to your needs.",
  },
  {
    icon: BadgeDollarSign,
    title: "Cost-Efficiency",
    description:
      "Pay only for what you use. Our pricing models are designed to optimize your budget while providing top-notch services.",
  },
  {
    icon: ShieldCheck,
    title: "Security",
    description:
      "Your data's safety is our priority. We implement robust security measures and compliance protocols to protect your sensitive information.",
  },
  {
    icon: Globe,
    title: "Accessibility",
    description:
      "Work from anywhere! With our cloud solutions, all your applications and data are accessible from any device with an internet connection.",
  },
];

export default function CloudSolutionsSection() {
  return (
    <section className="pb-12 pt-16">
      <div className="max-w-6xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-16">
          {/* <p className="text-sm font-semibold uppercase tracking-widest text-purple-400 mb-3">
            Why Choose Us
          </p> */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Our Cloud Solutions
          </h2>
          {/* <div className="w-16 h-1 bg-gradient-to-r from-purple-600 to-blue-600 mx-auto rounded-full" /> */}
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {solutions.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={idx}
                className="group relative rounded-2xl border border-purple-500/20 bg-gradient-to-br from-purple-600/5 to-blue-600/5 overflow-hidden cursor-default"
                style={{
                  minHeight: "260px",
                  transition: "border-color 0.6s ease, background 0.6s ease, box-shadow 0.6s ease",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = "rgba(168,85,247,0.5)";
                  e.currentTarget.style.boxShadow = "0 0 40px rgba(139,92,246,0.15), 0 0 80px rgba(59,130,246,0.08)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = "rgba(168,85,247,0.2)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                {/* Background glow blob */}
                <div
                  className="absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-gradient-to-br from-purple-600 to-blue-600 blur-3xl pointer-events-none"
                  style={{
                    opacity: 0,
                    transition: "opacity 0.7s ease",
                  }}
                  ref={el => {
                    if (el) {
                      const parent = el.parentElement;
                      parent.addEventListener("mouseenter", () => el.style.opacity = "0.12");
                      parent.addEventListener("mouseleave", () => el.style.opacity = "0");
                    }
                  }}
                />

                {/* DEFAULT STATE */}
                <div
                  className="absolute inset-0 flex flex-col items-center justify-center gap-5 p-8"
                  style={{ transition: "opacity 0.5s ease, transform 0.5s ease" }}
                  ref={el => {
                    if (el) {
                      const parent = el.parentElement;
                      parent.addEventListener("mouseenter", () => {
                        el.style.opacity = "0";
                        el.style.transform = "translateY(-16px)";
                      });
                      parent.addEventListener("mouseleave", () => {
                        el.style.opacity = "1";
                        el.style.transform = "translateY(0)";
                      });
                    }
                  }}
                >
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center text-white shadow-xl shadow-purple-900/40">
                    <Icon className="w-7 h-7" />
                  </div>
                  <h3 className="text-white font-bold text-xl text-center leading-snug">
                    {item.title}
                  </h3>
                </div>

                {/* HOVER STATE */}
                <div
                  className="absolute inset-0 flex flex-col justify-end gap-4 p-8"
                  style={{
                    opacity: 0,
                    transform: "translateY(16px)",
                    transition: "opacity 0.5s ease, transform 0.5s ease",
                  }}
                  ref={el => {
                    if (el) {
                      const parent = el.parentElement;
                      parent.addEventListener("mouseenter", () => {
                        el.style.opacity = "1";
                        el.style.transform = "translateY(0)";
                      });
                      parent.addEventListener("mouseleave", () => {
                        el.style.opacity = "0";
                        el.style.transform = "translateY(16px)";
                      });
                    }
                  }}
                >
                  {/* Title */}
                  <h3 className="text-white font-bold text-xl leading-snug">
                    {item.title}
                  </h3>

                  {/* Divider */}
                  {/* <div className="w-10 h-0.5 rounded-full bg-gradient-to-r from-purple-500 to-blue-500" /> */}

                  {/* Description */}
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}